import React from "react";
import { MdOutlineDevices } from "react-icons/md";
import { CgBoy } from "react-icons/cg";
import {FaLongArrowAltDown} from "react-icons/fa"
import "./ImagingThink.css";
import {AiFillPieChart} from "react-icons/ai";
import {FaChartPie} from "react-icons/fa"
import {FaCalculator} from "react-icons/fa"
import {MdCall} from "react-icons/md"

import {GiThink} from "react-icons/gi"
import withRedcliffe from "../../Assets/Group 11299.svg"
import withoutRedcliffe from "../../Assets/Group 10995.svg"



import { IoFootsteps } from "react-icons/io5";
function ImagingThink(){
    return(
            <div className="ImagingThinkMainNew">
        <div className="ImagingThinkMain container">
            <div className="ImagingThinkPara">
            <h1>Think Radiology, Think Redcliffe Labs</h1>
            <p>Redcliffe Imaging offer specialised diagnostic imaging including radiology and diagnostic services. Through our wide network of diagnostic centres across the country, we offer an expansive range of tests and modalities that cover a comprehensive range of specialties and disciplines.</p>
            </div>

            <div className="ImagingThinkRoadmap1">
                {/* <img src={withRedcliffe} alt="withRedcliffe"/> */}
                    <p>WITH REDCLIFFE LABS</p>
                    <div className="ImagingThinkRoadmap1Div">
                    <img src={withRedcliffe} alt="withRedcliffe" />

                        {/* <div className="underImagingThinkRoadmap1Div">
                                <MdOutlineDevices style={{height:"33px", width:"20px", color:"#76BEC9"}} />
                        </div>
                                <FaLongArrowAltDown className="ForArrow" />
                        <div className="underImagingThinkRoadmap1Div">
                                <CgBoy style={{height:"33px", width:"20px", color:"#76BEC9"}} />
                        </div>
                                <FaLongArrowAltDown className="ForArrow"  />
                        <div className="underImagingThinkRoadmap1Div">
                            <p>Your Scan</p>
                        </div> */}
                    </div>
            </div>

            <div className="ImagingThinkRoadmap2">
                    <p>WITHOUT REDCLIFFE LABS</p>
                    <div className="ImagingThinkRoadmap1Div">
                    {/* <div className="ImagingThinkRoadmap2Div1">
                        <div className="underImagingThinkRoadmap2Div">
                            <IoFootsteps style={{height:"33px", width:"20px", color:"#B47C85"}} />

                        </div>
                    </div> */}
                                        <img src={withoutRedcliffe} alt="withoutRedcliffe" />

                    {/* <div className="ImagingThinkRoadmap2Div">
                        <div className="underImagingThinkRoadmap2Div">
                                <MdCall style={{height:"33px", width:"20px", color:"#B47C85"}} />
                        </div>
                                
                                <FaLongArrowAltDown className="ForArrow"  />
                               
                        <div className="underImagingThinkRoadmap2Div">
                                <FaChartPie style={{height:"33px", width:"20px", color:"#B47C85"}} />
                        </div>
                                <FaLongArrowAltDown className="ForArrow"  />
                               
                        <div className="underImagingThinkRoadmap2Div">
                                <GiThink style={{height:"33px", width:"20px", color:"#B47C85"}} />
                        </div>
                        <FaLongArrowAltDown className="ForArrow"  />
                        <div className="underImagingThinkRoadmap2Div">
                        <MdCall style={{height:"33px", width:"20px", color:"#B47C85"}} />
                        </div>
                                <FaLongArrowAltDown className="ForArrow"  />
                        <div className="underImagingThinkRoadmap2Div">
                            <p>Your Scan</p>
                        </div>
                    </div> */}
                  
                    {/* <div className="ImagingThinkRoadmap2Div3">
                        <div className="underImagingThinkRoadmap2Div">
                                <FaCalculator style={{height:"33px", width:"15px", color:"#B47C85"}} />
                        </div>
                        <FaLongArrowAltDown style={{height:"18px", width:"10px", margin:"0% 48%"}} />
                        <div className="underImagingThinkRoadmap2Div">
                                 <FaCalculator style={{height:"33px", width:"15px", color:"#B47C85"}} />
                        </div>
                                <FaLongArrowAltDown style={{height:"18px", width:"10px", margin:"0% 48%"}} />
                        <div className="underImagingThinkRoadmap2Div">
                        <GiThink style={{height:"33px", width:"20px", color:"#B47C85"}} />
                        </div>
                    </div> */}
                    
                   
                    </div>
            </div>

        </div>
        </div>
    )
}

export default ImagingThink;